/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentFeedbackQueryVariables = Types.Exact<{
  conversationId: Types.Scalars['ID']['input'];
}>;


export type AgentFeedbackQuery = { agentFeedback: { __typename: 'AgentFeedbackResult', ratings: Array<{ __typename: 'AgentFeedbackRating', messageId: string, rating: number, comment: string }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type SetAgentFeedbackMutationVariables = Types.Exact<{
  input: Types.SetAgentFeedbackInput;
}>;


export type SetAgentFeedbackMutation = { setAgentFeedback: { __typename: 'SetAgentFeedbackResult', stored: boolean } };


export const AgentFeedbackDocument = gql`
    query AgentFeedback($conversationId: ID!) {
  agentFeedback(conversationId: $conversationId) {
    __typename
    ... on AgentFeedbackResult {
      ratings {
        messageId
        rating
        comment
      }
    }
  }
}
    `;

/**
 * __useAgentFeedbackQuery__
 *
 * To run a query within a React component, call `useAgentFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentFeedbackQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useAgentFeedbackQuery(baseOptions: Apollo.QueryHookOptions<AgentFeedbackQuery, AgentFeedbackQueryVariables> & ({ variables: AgentFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentFeedbackQuery, AgentFeedbackQueryVariables>(AgentFeedbackDocument, options);
      }
export function useAgentFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentFeedbackQuery, AgentFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentFeedbackQuery, AgentFeedbackQueryVariables>(AgentFeedbackDocument, options);
        }
export function useAgentFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentFeedbackQuery, AgentFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentFeedbackQuery, AgentFeedbackQueryVariables>(AgentFeedbackDocument, options);
        }
export type AgentFeedbackQueryHookResult = ReturnType<typeof useAgentFeedbackQuery>;
export type AgentFeedbackLazyQueryHookResult = ReturnType<typeof useAgentFeedbackLazyQuery>;
export type AgentFeedbackSuspenseQueryHookResult = ReturnType<typeof useAgentFeedbackSuspenseQuery>;
export type AgentFeedbackQueryResult = Apollo.QueryResult<AgentFeedbackQuery, AgentFeedbackQueryVariables>;
export const SetAgentFeedbackDocument = gql`
    mutation SetAgentFeedback($input: SetAgentFeedbackInput!) {
  setAgentFeedback(input: $input) {
    stored
  }
}
    `;
export type SetAgentFeedbackMutationFn = Apollo.MutationFunction<SetAgentFeedbackMutation, SetAgentFeedbackMutationVariables>;

/**
 * __useSetAgentFeedbackMutation__
 *
 * To run a mutation, you first call `useSetAgentFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgentFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgentFeedbackMutation, { data, loading, error }] = useSetAgentFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAgentFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SetAgentFeedbackMutation, SetAgentFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAgentFeedbackMutation, SetAgentFeedbackMutationVariables>(SetAgentFeedbackDocument, options);
      }
export type SetAgentFeedbackMutationHookResult = ReturnType<typeof useSetAgentFeedbackMutation>;
export type SetAgentFeedbackMutationResult = Apollo.MutationResult<SetAgentFeedbackMutation>;
export type SetAgentFeedbackMutationOptions = Apollo.BaseMutationOptions<SetAgentFeedbackMutation, SetAgentFeedbackMutationVariables>;